import { EmailTemplateTypes } from 'shared';

export const types = {
  [EmailTemplateTypes.LATE_FEE]: `Late Fee`,
  [EmailTemplateTypes.REMINDER]: `Invoice Reminder`,
  [EmailTemplateTypes.AFTER_MARKED_PAID]: `Invoice Marked Paid`,
  [EmailTemplateTypes.DISCOUNT]: `Discount`,
  [EmailTemplateTypes.STATEMENT_EMAIL]: `Statement`,
  [EmailTemplateTypes.STATEMENT_INTEREST_EMAIL]: `Statement Interest`,
  [EmailTemplateTypes.QUOTE]: `Quote`,
  [EmailTemplateTypes.ANNOUNCEMENT]: `Announcement`,
  [EmailTemplateTypes.PAYMENT_PLAN_REMINDER]: `Payment Plan Reminder`,
};

// Colour dot per type group, shown in the nested sidebar and next to each
// row so a type can be spotted at a glance. Keyed like templateGroupLabels.
export const templateGroupDots = {
  [EmailTemplateTypes.LATE_FEE]: `bg-orange-500`,
  [EmailTemplateTypes.REMINDER]: `bg-blue-500`,
  [EmailTemplateTypes.AFTER_MARKED_PAID]: `bg-green-500`,
  [EmailTemplateTypes.DISCOUNT]: `bg-purple-500`,
  [EmailTemplateTypes.STATEMENT_EMAIL]: `bg-indigo-500`,
  [EmailTemplateTypes.STATEMENT_INTEREST_EMAIL]: `bg-indigo-400`,
  [EmailTemplateTypes.QUOTE]: `bg-teal-500`,
  [EmailTemplateTypes.ANNOUNCEMENT]: `bg-slate-400`,
  [EmailTemplateTypes.PAYMENT_PLAN_REMINDER]: `bg-sky-500`,
  OTHER: `bg-gray-400`,
};

// Type filter options for the templates list, shared between the page and
// the nested sidebar so they stay in sync. Types without a label in `types`
// (eg SMS) fall into `Other`.
export const templateGroupLabels = {
  ...types,
  OTHER: `Other`,
};

export const templateGroupOrder = Object.keys(templateGroupLabels);

export function templateGroupKey(type: string) {
  return types[type] ? type : `OTHER`;
}

// URL slug for each type filter, eg /settings/email-templates/late-fee.
// Each slug is registered as a static route so they can never collide with
// the /email-templates/:templateId detail route.
export const templateGroupSlugs = {
  [EmailTemplateTypes.LATE_FEE]: `late-fee`,
  [EmailTemplateTypes.REMINDER]: `invoice-reminder`,
  [EmailTemplateTypes.AFTER_MARKED_PAID]: `invoice-marked-paid`,
  [EmailTemplateTypes.DISCOUNT]: `discount`,
  [EmailTemplateTypes.STATEMENT_EMAIL]: `statement`,
  [EmailTemplateTypes.STATEMENT_INTEREST_EMAIL]: `statement-interest`,
  [EmailTemplateTypes.QUOTE]: `quote`,
  [EmailTemplateTypes.ANNOUNCEMENT]: `announcement`,
  [EmailTemplateTypes.PAYMENT_PLAN_REMINDER]: `payment-plan-reminder`,
  OTHER: `other`,
};

export function templateGroupFromSlug(slug: string) {
  return Object.keys(templateGroupSlugs).find(key => templateGroupSlugs[key] === slug) ?? null;
}

export const VARIATIONS_EXPLAINER = `One variation is picked at random each time this template is sent. Variations only change the subject and body, everything else comes from the original.`;
